export var LEFT_MOUSE = 0;
export var RIGHT_MOUSE = 2;
export var TAB = 9;
export var ENTER = 13;
export var ESC = 27;
export var SPACE = 32;
export var PAGE_UP = 33;
export var PAGE_DOWN = 34;
export var END = 35;
export var HOME = 36;
export var LEFT = 37;
export var UP = 38;
export var RIGHT = 39;
export var DOWN = 40;
export var ZERO = 48;
export var NINE = 57;
export var KEYPAD_ZERO = 96;
export var KEYPAD_NINE = 105;